import { render, staticRenderFns } from "./TestBreadcrumb.vue?vue&type=template&id=3bb22004&scoped=true&"
import script from "./TestBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./TestBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb22004",
  null
  
)

export default component.exports